import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import Dashboard from '../views/Dashboard.vue'
import Promo from '../views/Promo.vue'
import Locations from '../views/LocationsPage.vue'
import Chat from '../views/Chat.vue' // ✅ เพิ่มตรงนี้
import Orders from '../views/Orders.vue'


const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '', name: 'MainUI', component: Dashboard },
      { path: 'promo', name: 'Promo', component: Promo },
      { path: 'locations', name: 'Locations', component: Locations },
      { path: 'chat/:user_id', name: 'Chat', component: Chat } ,// ✅ เพิ่มตรงนี้
      { path: 'orders', name: 'Orders', component: Orders }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
